import { Provider } from "./provider/Provider";

const DestekService = {
  destekTalepleri: ({ user, status, date, start, limit, order }) => {
    return Provider({
      user,
      status,
      date,
      start,
      limit,
      order,
      methodName: "Module/Destek/DestekTalepleri",
    });
  },
  talepMesajlar: (talepCode) => {
    return Provider({
      talepCode,
      methodName: "Module/Destek/TalepMesajlar",
    });
  },
  mesajGonder: ({ talepCode, message }) => {
    return Provider({
      talepCode,
      message,
      methodName: "Module/Destek/PanelMesajGonder",
    });
  },
  mesajDuzenle: ({ mesajCode, message }) => {
    return Provider({
      mesajCode,
      message,
      methodName: "Module/Destek/PanelMesajDuzenle",
    });
  },
  mesajKaldir: ({ mesajCode }) => {
    return Provider({
      mesajCode,
      methodName: "Module/Destek/PanelMesajKaldir",
    });
  },
  destekDurumDegis: ({ talepCode, durum }) => {
    return Provider({
      talepCode,
      durum,
      methodName: "Module/Destek/DestekDurumDegis",
    });
  },
  destekDurumlariDegis: ({ talepCodes, durum }) => {
    return Provider({
      talepCodes,
      durum,
      methodName: "Module/Destek/DestekDurumlariDegis",
    });
  },
};

export default DestekService;
